/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Aria_CopiedInputs */

const en_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to clipboard`)
};

const ar_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم النسخ إلى الحافظة`)
};

const bn_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্লিপবোর্ডে কপি হয়েছে`)
};

const de_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In die Zwischenablage kopiert`)
};

const es_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado al portapapeles`)
};

const fr_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié dans le presse-papiers`)
};

const pt_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado para a área de transferência`)
};

const zh_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制到剪贴板`)
};

const tr_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoya kopyalandı`)
};

const ru_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировано в буфер обмена.`)
};

const pl_copy_aria_copied = /** @type {(inputs: Copy_Aria_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiowano do schowka`)
};

/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Copy_Aria_CopiedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const copy_aria_copied = /** @type {((inputs?: Copy_Aria_CopiedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Aria_CopiedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_copy_aria_copied(inputs)
	if (locale === "bn") return bn_copy_aria_copied(inputs)
	if (locale === "de") return de_copy_aria_copied(inputs)
	if (locale === "es") return es_copy_aria_copied(inputs)
	if (locale === "fr") return fr_copy_aria_copied(inputs)
	if (locale === "pt") return pt_copy_aria_copied(inputs)
	if (locale === "zh") return zh_copy_aria_copied(inputs)
	if (locale === "tr") return tr_copy_aria_copied(inputs)
	if (locale === "ru") return ru_copy_aria_copied(inputs)
	if (locale === "pl") return pl_copy_aria_copied(inputs)
	return en_copy_aria_copied(inputs)
});